import { Action } from '..'
import { EmailActionNode, SlackAlertActionNode } from '../../node/types'
import DolfinRecord from '../../record'
import { DolfinRpc } from '../../rpc'

export abstract class MessagingAction<
  TNode extends EmailActionNode | SlackAlertActionNode
> extends Action<TNode> {
  constructor(node: TNode, record: DolfinRecord, organizationId: number, rpcClient: DolfinRpc) {
    super(node, record, organizationId, rpcClient)
  }

  protected parseText(text: string): string {
    const regex = /\{([a-z]+(?:_[a-z]+)*)}/g
    const matches = text.match(regex)

    if (!matches) {
      return text
    }

    const variables = matches.map(m => m.replace('{', '').replace('}', ''))

    return variables.reduce((acc, variable) => {
      const variableValue = this.recordData.getFieldValue(variable)

      if (variableValue == null) {
        return acc
      }

      return acc.replace(`{${variable}}`, variableValue as string)
    }, text)
  }

  parseVariables(): Record<string, string> | undefined {
    if (!this.node.data.formData.variables || !this.node.data.formData.template_values_replaced) {
      console.error('Missing required fields for messaging action', this.node.data.formData)
      return undefined
    }

    return this.node.data.formData.variables?.reduce(
      (acc, variable, index) => {
        const templateValue = this.node.data.formData.template_values_replaced?.[index]
        if (variable.type === 'text') {
          acc[variable.type] = this.parseText(templateValue ?? '')

          return acc
        }

        acc[variable.type] = (templateValue as string) ?? ''
        return acc
      },
      {} as Record<string, string>
    )
  }
}
